import { defineComponent as l, useTemplateRef as u, createElementBlock as f, openBlock as c, mergeProps as m, unref as r, renderSlot as d } from "vue";
import s from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/DescriptionList/description-list.js";
import { useOUIAProps as T } from "../../helpers/ouia.js";
const k = /* @__PURE__ */ l({
  name: "PfDescriptionListTermHelpTextButton",
  __name: "DescriptionListTermHelpTextButton",
  props: {
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(p) {
    const n = p, a = T({ id: n.ouiaId, safe: n.ouiaSafe }), t = u("helpTextRef");
    function i(e) {
      if (!t.value || t.value !== e.target)
        return;
      const o = e.key;
      (o === "Enter" || o === " ") && (e.preventDefault(), t.value.click());
    }
    return (e, o) => (c(), f("span", m({ ref: "helpTextRef" }, r(a), {
      class: [r(s).descriptionListText, r(s).modifiers.helpText],
      role: "button",
      onKeydown: i
    }), [
      d(e.$slots, "default")
    ], 16));
  }
});
export {
  k as default
};
